<template>
<div>

<v-layout d-flex>

<v-card>
<v-toolbar height="42" flat>
<v-toolbar-title><v-icon color="#4A76A8" left>mdi-comment-multiple-outline</v-icon>  Мои посты ({{posts.postList.length}})</v-toolbar-title>
<v-spacer></v-spacer>

<v-tooltip left  max-width="250">
<v-btn slot="activator"  color="#4A76A8"   flat small icon> <v-icon @click="posts.modals.creator=true">mdi-plus</v-icon> </v-btn>
<span>Добавить пост или шаблон</span>
</v-tooltip>

<v-tooltip left v-if="posts.postList.filter(item => item.is_important==0).length > 0"  max-width="250">
<v-btn slot="activator"  color="red"   flat small icon> <v-icon @click="posts.modals.deleteAllPosts=true">mdi-delete</v-icon> </v-btn>
<span>Удалить посты, кроме избранных</span>
</v-tooltip>

<v-tooltip left v-if="posts.postList.filter(item => item.is_important==0).length < 1 && posts.postList.filter(item => item.is_important==1).length > 0"  max-width="250">
<v-btn disabled slot="activator"  color="grey"   flat small icon> <v-icon >mdi-delete</v-icon> </v-btn>
<span style="color:yellow "><v-icon small color="yellow">mdi-alert</v-icon> У вас все посты отмечены как избранные, снимите отметки <v-icon small>mdi-star</v-icon>  что бы их удалить.</span>
</v-tooltip>

</v-toolbar>


<v-card-text>

<postTable :posts="posts"></postTable>

</v-card-text>

</v-card>
</v-layout>


<!-- Диалоговые окна  -->
<v-dialog persistent scrollable v-model="posts.modals.creator" width="550">
<creator :posts="posts" ></creator>
</v-dialog>

<v-dialog persistent scrollable v-model="posts.modals.deletePost" width="450">
<deletePost :posts="posts" ></deletePost>
</v-dialog>

<v-dialog persistent scrollable v-model="posts.modals.deleteAllPosts" width="550">
<deleteAllPosts :posts="posts" ></deleteAllPosts>
</v-dialog>

<v-dialog persistent scrollable v-model="posts.modals.editor" width="950">
<editor :posts="posts" ></editor>
</v-dialog>
<!-- Диалоговые окна  закрываем -->
</div>
</template>




<script>
import axios from 'axios'
import postTable from './postTable.vue'
import deletePost from './deletePost'
import deleteAllPosts from './deleteAllPosts.vue'
import creator from './creator.vue'
import editor from './editor.vue'
export default {
components:{postTable,creator,deletePost,deleteAllPosts,editor},
data(){
return {
posts:{
newPost:{
  accGroupId:"2",
  selectedAcc:[],
  accGroupsList:[],
  accountsAll: [],
  post:{
    text:"",
    linkUrl:"",
    pin:true,
    close_comments:true,
    add_like:false,
    make_comment:{
      is:false,
      text:""
    },
  },
},
editStatus: "edit",  // copy  // create
selectedPost:{},
taskList:[],
modals:{
  creator:false,
  deletePost:false,
  editor:false,
  newPost:false,
  deleteAllPosts:false,
},
creator:{
  post_id:"",
  task_id:"",
  status:"1",
  acc_block_repost_count : "0",
  acc_block_link_count : "0",
  repost_count : "0",
  link_count : "0",
  sms_count : "0",
params:{
set_importance:false,
check_post:{
     last_time:"",
     interval:0,
     linkStatus:'ok',
     linkUrl:'',
     pageType:'page',
     page:{
       id:"",
       photo_50:"",
       deactivated:"",
       first_name:"",
       last_name:""
     },
     group:{
       id:"",
       name:"",
       photo_50:"",
       deactivated:"",   // banned
     },
     post:{
       id:"",
       date:"",
       is_deleted:"",
       deleted_reason:""
     },
},
blockActTime:{
     min:3,
     acc_count:5,
     first_block_time:'',
     last_block_time:'',
     block_count:0
},
selectedActBlock:{
     selected:'nothing',
     actions:[
       {title:'Ничего не делать',value:'nothing'},
       {title:'Заменить другим действием',value:'ch_act'},
       {title:'Заменить пост',value:'ch_post'},
     ],
},
allActsBlock:{
     selected:'nothing',
     actions:[
       {title:'Ничего не делать',value:'nothing'},
       {title:'Заменить пост',value:'ch_act'},
     ],
},
postDeletedFromPage:{
     selected:'ch_post',
     actions:[
       {title:'Заменить пост',value:'ch_post'},
     ],
},
autoGenerate:{
     is:false,
     pattern:"",
     selectedAccGroup:"1",
     onlyWithoutPosts:true,
     onlyOpenedAccounts:true,
     linkUrl:"",
     pin:true,
     close_comments:true,
     add_like:false,
     make_comment:{
       is:false,
       text:""
     },

  },
  selectedAct:'repost',
  acts:{
    repost:{
      limit:600,
      is:true,
      isBlock:false,
      accountsBlock:[],
      helloSms:{
        text:""
      },
      sms:{
        text:"<имя>"
      },
    },
    link:{
      limit:600,
      is:false,
      isBlock:false,
      accountsBlock:[],
      helloSms:{
        text:""
      },
      sms:{
        beforeLink:"Доброго время суток",
        afterLink:"и спасибо вам <имя>",
      },
      links:{
        linkOnPage:false,
        linkOnPost:false,
        linkOnPostSimple:false,
        hyperLink:{
          is:true,
          text:'{нажми сюда|перейди тут|подробности тут}',
        },
      },
    },
    smsWithoutLink:{
      limit:600,
      is:false,
      isBlock:false,
      accountsBlock:[],
      sms:{
        text:"<имя> у меня на странице, в первом посте...."
      },
      makeRepostOnWall:{
        pin:true,
        closeComments:true,
        text:''
      },
    },
},
  },
},
tablePostFields:[
  {key:'post_id',label:'Пост'},
  {key:'task',label:'Задание'},
  {key:'status',label:'Статус'},
  {key:'options',label:'Параметры'},



],
postList:[

],
},
}
},

methods:{
getPosts(){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/posts/posts_get.php', {
contentType: 'JSONP',method: 'get'})
.then(response => {
response.data  = response.data.sort(function(a, b){return a.is_important - b.is_important})
this.posts.postList = response.data
})
},

},

created(){
this.getPosts()
},

}
</script>
